'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Make item field table headings accessible compliant.
 */
function fieldHeadingLabel(key) {
  return key && key === 'table_headings_item_select' ? _react2.default.createElement(
    _baseScreenReaderMessage2.default,
    null,
    _react2.default.createElement(_reactIntl.FormattedMessage, { id: key })
  ) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: key });
}

var TableHeader = function (_BcReactComponent) {
  _inherits(TableHeader, _BcReactComponent);

  function TableHeader(props) {
    _classCallCheck(this, TableHeader);

    var _this = _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call(this, props));

    _this.bindAll('renderFieldHeading', 'renderSortButton');
    return _this;
  }

  _createClass(TableHeader, [{
    key: 'renderFieldHeading',
    value: function renderFieldHeading(field) {
      var key = field.headerKey || field.key;
      var className = (0, _classnames2.default)(field.type && field.type.toLowerCase(), {
        'right-align': field.rightAlign
      });

      return _react2.default.createElement(
        'th',
        { scope: 'col', key: key, className: className },
        this.props.sortable ? this.renderSortButton(key) : fieldHeadingLabel(key)
      );
    }
  }, {
    key: 'renderSortButton',
    value: function renderSortButton(key) {
      var _this2 = this;

      var _props = this.props,
          sortDirection = _props.sortDirection,
          currentSortField = _props.currentSortField,
          intl = _props.intl;

      var currentSortOrder = sortDirection === 'asc' ? _baseIcons.Sort.Up : _baseIcons.Sort.Down;
      var SortArrows = currentSortField === key ? currentSortOrder : _baseIcons.Sort.SortArrows;

      return _react2.default.createElement(
        _baseButtons.TextButton,
        {
          className: 'table-sort',
          handleClick: function handleClick() {
            return _this2.props.changeSortField(key);
          },
          'aria-label': intl.formatMessage({ id: 'change_sort_direction' }, { key: intl.formatMessage({ id: key }) }) },
        fieldHeadingLabel(key),
        _react2.default.createElement(SortArrows, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var fields = this.props.fields;

      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          { className: 'clearfix' },
          fields.map(this.renderFieldHeading)
        )
      );
    }
  }]);

  return TableHeader;
}(_baseBcReactComponent2.default);

TableHeader.propTypes = {
  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    key: _react.PropTypes.string.isRequired,
    headerKey: _react.PropTypes.string,
    type: _react.PropTypes.string.isRequired,
    localizationMap: _react.PropTypes.func
  }).isRequired).isRequired,
  changeSortField: _react.PropTypes.func.isRequired,
  sortable: _react.PropTypes.bool,
  sortDirection: _react.PropTypes.string,
  currentSortField: _react.PropTypes.string
};

exports.default = (0, _reactIntl.injectIntl)(TableHeader);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table-header/components/TableHeader.component.js
// module id = 1351
// module chunks = 1